'use client';
import type {FC} from 'react';
import {HeroPinned} from './HeroPinned';
import {HeroStatic} from './HeroStatic';
import {DEFAULT_HERO_MODE, DEFAULT_HERO_SIZE, HeroMode, type HeroSectionProps, type HeroShellProps} from './types';

const HERO_BY_MODE: Record<HeroMode, FC<HeroShellProps>> = {
  [HeroMode.PinnedCurtain]: HeroPinned,
  [HeroMode.Static]: HeroStatic,
};

export function HeroSection({mode = DEFAULT_HERO_MODE, size = DEFAULT_HERO_SIZE, ...content}: HeroSectionProps) {
  const Hero = HERO_BY_MODE[mode];
  return <Hero {...content} size={size} />;
}

HeroSection.displayName = 'HeroSection';
